<template>
  <div class="home">
    <h1>小鸡毛和小白的旅行手册</h1>
    <el-button type="primary" @click="goToMap('2410guiyang','baidu')">贵阳</el-button>
    <el-button type="primary" @click="goToMap('2410aomen', 'google')">澳门</el-button>
    <el-button type="primary" @click="goToMap('2411riben', 'google')">日本</el-button>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Home',
  methods: {
    goToMap(place, mapProvider) {
      if (mapProvider === 'baidu') {
        this.$router.push('map?'+place)
      } else {
        this.$router.push('maps?'+place)
      }
    },
  }
}

</script>

<style scoped>
.home {
  height: 100vh;
}
img {
  max-width: 95%;
}
</style>
